<tiime-slide-toggle-container [selected]="inviteToApps.value">
  <mat-slide-toggle
    color="primary"
    [formControl]="inviteToApps"
    slideToggleContainerPrefix
    (click)="$event.stopPropagation()"
  ></mat-slide-toggle>
  <div slideToggleContainerContent>Inviter mon client sur les applications Tiime</div>
</tiime-slide-toggle-container>
@if (inviteToApps.value) {
  <div class="invitation-channel-container flex column align-center gap-10">
    Envoyer l'invitation par
    <app-invitation-channel-select
      [userPhone]="userPhoneNumber()"
      [formControl]="invitationForm.channels"
      [displayTitle]="false"
      [displayIcons]="false"
    ></app-invitation-channel-select>
  </div>
  <tiime-slide-toggle-container [selected]="invitationForm.controls.withFormation.value">
    <mat-slide-toggle
      color="primary"
      [formControl]="invitationForm.controls.withFormation"
      slideToggleContainerPrefix
      (click)="$event.stopPropagation()"
    ></mat-slide-toggle>
    <div slideToggleContainerContent>
      J’autorise Tiime à contacter le client pour le former sur les Applications Tiime
    </div>
  </tiime-slide-toggle-container>
}
